
import './App.css';
import Hero from './components/Hero';
import FullScreenNavbar from './components/Navbar';
import ChooseCarColor from './components/choose-car-color/ChooseCarColor';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
     <FullScreenNavbar/>
     <Hero/>
     <ChooseCarColor/>
     <Footer/>
    </div>
  );
}

export default App;
